import { TwoFactorModalController } from './twoFactorModal.controller';
import template from './twoFactorModal.html';

export const twoFactorModalComponent = {
  name: 'twoFactor',
  restrict: 'E',
  controller: TwoFactorModalController,
  controllerAs: 'vm',
  template,
  transclude: true,
  bindings: {
    isProtected: '<?',
    onResolve: '&'
  }
};
